module.exports = __webpack_public_path__ + "img/fifa.2dd72f09.svg";